import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "flex items-center justify-between border-b border-slate-200 px-6 py-4"
};
const _hoisted_2 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_3 = {
  class: "min-h-0 flex-1 overflow-y-auto p-6"
};
const _hoisted_4 = {
  class: "grid grid-cols-1 gap-4 md:grid-cols-2"
};
const _hoisted_5 = {
  class: "block"
};
const _hoisted_6 = {
  class: "block"
};
const _hoisted_7 = {
  class: "block"
};
const _hoisted_8 = {
  class: "block"
};
const _hoisted_9 = {
  class: "block"
};
const _hoisted_10 = {
  class: "block"
};
const _hoisted_11 = {
  class: "block"
};
const _hoisted_12 = {
  key: 0,
  class: "block"
};
const _hoisted_13 = {
  class: "crm-customer-readonly form-readonly w-full"
};
const _hoisted_14 = {
  key: 1,
  class: "block"
};
const _hoisted_15 = {
  class: "block"
};
const _hoisted_16 = {
  class: "block"
};
const _hoisted_17 = {
  class: "block md:col-span-2"
};
const _hoisted_18 = {
  class: "block md:col-span-2"
};
const _hoisted_19 = {
  class: "flex justify-end gap-3 border-t border-slate-200 px-6 py-4"
};
const _hoisted_20 = ["disabled"];
import { computed, reactive, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { getCustomer } from '@/api/customer';
import { createWealthCustomer, updateWealthCustomer } from '@/api/wealth';
import AppModal from '@/components/AppModal.vue';
import CustomerSelector from '@/components/CustomerSelector/index.vue';
import { cleanPayload, genderOptions, idTypeOptions, riskLevelOptions } from '../utils';
export default {
  __name: 'WealthCustomerFormModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    customer: {
      type: Object,
      default: null
    },
    submitting: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'saved'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const form = reactive(defaultForm());
    const linkedCrmCustomerSnapshot = ref(null);
    const originalLinkedCrmCustomerId = ref(null);
    const hasOriginalLinkedCrmCustomer = computed(() => Boolean(originalLinkedCrmCustomerId.value));
    const linkedCrmCustomerDisplay = computed(() => {
      if (!originalLinkedCrmCustomerId.value) return '未关联';
      const customer = linkedCrmCustomerSnapshot.value;
      if (!customer) return `CRM客户 ${originalLinkedCrmCustomerId.value}`;
      return [customer.name, customer.phone || customer.customerNo].filter(Boolean).join(' / ') || `客户 ${customer.id}`;
    });
    function defaultForm() {
      return {
        id: null,
        name: '',
        mobile: '',
        idType: '',
        idNo: '',
        gender: '',
        birthday: '',
        address: '',
        emergencyContactName: '',
        emergencyContactMobile: '',
        riskLevel: 'LOW',
        linkedCrmCustomerId: null,
        remark: ''
      };
    }
    function reset(value = null) {
      Object.assign(form, defaultForm(), value || {});
      originalLinkedCrmCustomerId.value = value?.linkedCrmCustomerId || null;
      linkedCrmCustomerSnapshot.value = null;
    }
    function close() {
      emit('update:modelValue', false);
    }
    async function submit() {
      if (!form.name?.trim()) {
        ElMessage.warning('请填写客户姓名');
        return;
      }
      const payload = cleanPayload({
        name: form.name?.trim(),
        mobile: form.mobile?.trim(),
        idType: form.idType,
        idNo: form.idNo?.trim(),
        gender: form.gender,
        birthday: form.birthday,
        address: form.address?.trim(),
        emergencyContactName: form.emergencyContactName?.trim(),
        emergencyContactMobile: form.emergencyContactMobile?.trim(),
        riskLevel: form.riskLevel,
        remark: form.remark?.trim()
      });
      if (form.id) {
        await updateWealthCustomer(form.id, hasOriginalLinkedCrmCustomer.value ? payload : cleanPayload({
          ...payload,
          linkedCrmCustomerId: form.linkedCrmCustomerId
        }));
        ElMessage.success('财富客户已更新');
      } else {
        await createWealthCustomer(cleanPayload({
          ...payload,
          linkedCrmCustomerId: form.linkedCrmCustomerId
        }));
        ElMessage.success('财富客户已创建');
      }
      emit('saved');
      close();
    }
    function ensureSelectedCrmCustomer(value) {
      if (value?.linkedCrmCustomerId) {
        linkedCrmCustomerSnapshot.value = {
          id: value.linkedCrmCustomerId,
          name: value.linkedCrmCustomerName || `CRM客户 ${value.linkedCrmCustomerId}`,
          phone: value.linkedCrmCustomerMobile || ''
        };
      }
    }
    async function loadLinkedCrmCustomerSnapshot(value) {
      if (!value?.linkedCrmCustomerId) {
        linkedCrmCustomerSnapshot.value = null;
        return;
      }
      ensureSelectedCrmCustomer(value);
      try {
        const customer = await getCustomer(value.linkedCrmCustomerId);
        if (customer?.id === value.linkedCrmCustomerId) {
          linkedCrmCustomerSnapshot.value = customer;
        }
      } catch (error) {
        console.error('load linked CRM customer failed:', error);
      }
    }
    watch(() => props.customer, async value => {
      reset(value);
      await loadLinkedCrmCustomerSnapshot(value);
    }, {
      immediate: true
    });
    watch(() => props.modelValue, async value => {
      if (value) {
        reset(props.customer);
        await loadLinkedCrmCustomerSnapshot(props.customer);
      }
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(AppModal, {
        visible: __props.modelValue,
        size: "4xl",
        "z-index": 70,
        onClose: close
      }, {
        default: _withCtx(() => [_createElementVNode("header", _hoisted_1, [_createElementVNode("div", null, [_createElementVNode("h3", _hoisted_2, _toDisplayString(form.id ? '编辑财富客户' : '新建财富客户'), 1), _cache[12] || (_cache[12] = _createElementVNode("p", {
          class: "mt-1 text-sm text-slate-500"
        }, "客户证件唯一性和数据权限由后端校验。", -1))]), _createElementVNode("button", {
          type: "button",
          class: "rounded-md p-1.5 text-slate-400 hover:bg-slate-100 hover:text-slate-600",
          onClick: close
        }, [...(_cache[13] || (_cache[13] = [_createElementVNode("svg", {
          class: "h-5 w-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), _createElementVNode("main", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("label", _hoisted_5, [_cache[14] || (_cache[14] = _createElementVNode("span", {
          class: "form-label"
        }, [_createTextVNode("客户姓名 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.name = $event),
          class: "form-input w-full",
          placeholder: "请输入客户姓名"
        }, null, 512), [[_vModelText, form.name]])]), _createElementVNode("label", _hoisted_6, [_cache[15] || (_cache[15] = _createElementVNode("span", {
          class: "form-label"
        }, "手机号", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.mobile = $event),
          class: "form-input w-full",
          placeholder: "请输入手机号"
        }, null, 512), [[_vModelText, form.mobile]])]), _createElementVNode("label", _hoisted_7, [_cache[16] || (_cache[16] = _createElementVNode("span", {
          class: "form-label"
        }, "证件类型", -1)), _createVNode(_component_el_select, {
          modelValue: form.idType,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.idType = $event),
          class: "form-select w-full"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "请选择",
            value: ""
          }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(idTypeOptions), item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("label", _hoisted_8, [_cache[17] || (_cache[17] = _createElementVNode("span", {
          class: "form-label"
        }, "证件号", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.idNo = $event),
          class: "form-input w-full",
          placeholder: "请输入证件号"
        }, null, 512), [[_vModelText, form.idNo]])]), _createElementVNode("label", _hoisted_9, [_cache[18] || (_cache[18] = _createElementVNode("span", {
          class: "form-label"
        }, "性别", -1)), _createVNode(_component_el_select, {
          modelValue: form.gender,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.gender = $event),
          class: "form-select w-full"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "请选择",
            value: ""
          }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(genderOptions), item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("label", _hoisted_10, [_cache[19] || (_cache[19] = _createElementVNode("span", {
          class: "form-label"
        }, "出生日期", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.birthday = $event),
          type: "date",
          class: "form-input w-full"
        }, null, 512), [[_vModelText, form.birthday]])]), _createElementVNode("label", _hoisted_11, [_cache[20] || (_cache[20] = _createElementVNode("span", {
          class: "form-label"
        }, "风险等级", -1)), _createVNode(_component_el_select, {
          modelValue: form.riskLevel,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.riskLevel = $event),
          class: "form-select w-full"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "请选择",
            value: ""
          }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(riskLevelOptions), item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]), hasOriginalLinkedCrmCustomer.value ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_cache[21] || (_cache[21] = _createElementVNode("span", {
          class: "form-label"
        }, "关联 CRM 客户", -1)), _createElementVNode("div", _hoisted_13, _toDisplayString(linkedCrmCustomerDisplay.value), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_14, [_cache[22] || (_cache[22] = _createElementVNode("span", {
          class: "form-label"
        }, "关联 CRM 客户", -1)), _createVNode(CustomerSelector, {
          modelValue: form.linkedCrmCustomerId,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.linkedCrmCustomerId = $event),
          placeholder: "搜索客户姓名、手机号或企业名称",
          class: "w-full"
        }, null, 8, ["modelValue"])])), _createElementVNode("label", _hoisted_15, [_cache[23] || (_cache[23] = _createElementVNode("span", {
          class: "form-label"
        }, "紧急联系人", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.emergencyContactName = $event),
          class: "form-input w-full",
          placeholder: "联系人姓名"
        }, null, 512), [[_vModelText, form.emergencyContactName]])]), _createElementVNode("label", _hoisted_16, [_cache[24] || (_cache[24] = _createElementVNode("span", {
          class: "form-label"
        }, "紧急联系人手机号", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => form.emergencyContactMobile = $event),
          class: "form-input w-full",
          placeholder: "联系人手机号"
        }, null, 512), [[_vModelText, form.emergencyContactMobile]])]), _createElementVNode("label", _hoisted_17, [_cache[25] || (_cache[25] = _createElementVNode("span", {
          class: "form-label"
        }, "地址", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => form.address = $event),
          class: "form-input w-full",
          placeholder: "请输入地址"
        }, null, 512), [[_vModelText, form.address]])]), _createElementVNode("label", _hoisted_18, [_cache[26] || (_cache[26] = _createElementVNode("span", {
          class: "form-label"
        }, "备注", -1)), _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => form.remark = $event),
          rows: "3",
          class: "form-textarea w-full",
          placeholder: "请输入备注"
        }, null, 512), [[_vModelText, form.remark]])])])]), _createElementVNode("footer", _hoisted_19, [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          onClick: close
        }, "取消"), _createElementVNode("button", {
          type: "button",
          class: "btn-primary",
          disabled: __props.submitting,
          onClick: submit
        }, "保存", 8, _hoisted_20)])]),
        _: 1
      }, 8, ["visible"])]);
    };
  }
};